document.addEventListener("DOMContentLoaded", () => {
  const remoteSelect = document.querySelector(".remote-select");
  const remoteSelectBtn = document.querySelector(
    ".remote-select .select-button"
  );
  const selectedRemoteValue = document.querySelector(
    ".remote-select .selected-value"
  );
  const remoteOptionsList = document.querySelectorAll(
    ".remote-select .select-dropdown li"
  );
  const grInputs = document.getElementsByName("grommet-product");

  let frameColor = null;
  let builderPrice = null;
  let tableTopPrice = null;
  let tableSKU = "";
  let leftGrommetSize = null;
  let rightGrommetSize = null;
  let leftGrommetCount = null;
  let rightGrommetCount = null;

  // TableTop Selection Start
  const materialWrapper = document.querySelector(".material-options");
  const colorWrapper = document.querySelector(".color-options");
  const size_s = document.querySelector("#s_size_top .select-dropdown");
  const size_m = document.querySelector("#m_size_top .select-dropdown");
  const size_l = document.querySelector("#l_size_top .select-dropdown");
  const size_pb = document.querySelector("#pb_size_top");
  const size_p = document.querySelector(".single-size-row");
  const size_mdf = document.querySelector(".size-row");
  const size_s_Select = document.querySelector("#s_size_top");
  const size_m_Select = document.querySelector("#m_size_top");
  const size_l_Select = document.querySelector("#l_size_top");
  const size_s_SelectBtn = document.querySelector("#s_size_top .select-button");
  const size_m_SelectBtn = document.querySelector("#m_size_top .select-button");
  const size_l_SelectBtn = document.querySelector("#l_size_top .select-button");
  const selectedMaterial = document.querySelector("#selectedMaterial");
  const selectedColor = document.querySelector("#selectedColor");
  const selectedSize = document.querySelector("#selectedSize");
  const selectedFrame = document.querySelector("#selectedFrame");
  const colorInputs = document.getElementsByName("color");
  const sizeInputs = document.getElementsByName("size");
  const materials = document.getElementsByName("material");
  const frameColors = document.getElementsByName("frame_color");

  function updateSizeElement(array, select, name, group) {
    select.innerHTML = "";
    let sQty = 0,
      mQty = 0,
      lQty = 0;

    array.forEach((item, index) => {
      let value = item.id,
        title = item.title,
        topsQty = item.topsQty,
        sale = '',
        top_1_sku = item.top_1_sku,
        top_1_id = item.top_1_id,
        top_1_grommetQty = item.top_1_grommetQty,
        top_1_grommetSize = item.top_1_grommetSize,
        top_2_sku = item.top_2_sku,
        top_2_id = item.top_2_id,
        top_2_grommetQty = item.top_2_grommetQty,
        top_2_grommetSize = item.top_2_grommetSize,
        sizeGroup = parseFloat(item.size_group);

        if (item.sale) {
          sale = item.sale;
      }

      let radioElClass = "";
      let colorOptionClassName = "";
      if (name.indexOf("color") >= 0) {
        colorOptionClassName = `color_label option-${item.id}`;
        radioElClass = "custom-radio";
      }

      let checked_first = "";
      if (index == 0) {
        checked_first = "checked";
      } else {
        checked_first = "";
      }

      if (sizeGroup == 1) {
        sQty++;
      }
      if (sizeGroup == 2) {
        mQty++;
      }
      if (sizeGroup == 3) {
        lQty++;
      }

      if (sizeGroup == group) {
        let radioHtml = `
              <li role="option" class="">
                  <input 
                  type="radio"
                    class="${radioElClass}" 
                    name=${name}
                    id="${value}"
                    value="${value}"
                    data-title="${item.title}"
                    data-topsqty="${topsQty}"
                    data-sale="${sale}"
                    data-top_1_sku="${top_1_sku}"
                    data-top_1_id="${top_1_id}"
                    data-top_1_grommetqty="${top_1_grommetQty}"
                    data-top_1_grommetsize="${top_1_grommetSize}"
                    data-top_2_sku="${top_2_sku}"
                    data-top_2_id="${top_2_id}"
                    data-top_2_grommetqty="${top_2_grommetQty}"
                    data-top_2_grommetsize="${top_2_grommetSize}"
                    data-index=${index}
                    ${checked_first}
                      />
                      <label 
                        for="${value}" 
                        data-sale="${sale}"
                        class="${name}_${value} ${colorOptionClassName}">
                            ${title}</label>
                  </li>
              `;

        radioHtml.itemdata = item;
        select.insertAdjacentHTML("beforeend", radioHtml);
      }
      select.disabled = false;
    });

    if (sQty > 0) {
      size_s_SelectBtn.disabled = false;
    } else {
      size_s_SelectBtn.disabled = true;
    }
    if (mQty > 0) {
      size_m_SelectBtn.disabled = false;
    } else {
      size_m_SelectBtn.disabled = true;
    }
    if (lQty > 0) {
      size_l_SelectBtn.disabled = false;
    } else {
      size_l_SelectBtn.disabled = true;
    }
  }

  function updateRadioElement(array, select, name) {
    select.innerHTML = "";
    array.forEach((item, index) => {
      let value = item.id,
        title = item.title,
        topsQty = item.topsQty,
        sale = '',
        top_1_sku = item.top_1_sku,
        top_1_id = item.top_1_id,
        top_1_grommetQty = item.top_1_grommetQty,
        top_1_grommetSize = item.top_1_grommetSize,
        top_2_sku = item.top_2_sku,
        top_2_id = item.top_2_id,
        top_2_grommetQty = item.top_2_grommetQty,
        top_2_grommetSize = item.top_2_grommetSize;

        if (item.sale) {
          sale = item.sale;
      }
        
      let selectSingle = "";
      if (index == 0 && name == "material") {
        selectSingle = "checked";
      } else {
        selectSingle = "";
      }

      let radioElClass = "";
      let colorOptionClassName = "";
      if (name.indexOf("color") >= 0) {
        colorOptionClassName = `color_label option-${item.id}`;
        radioElClass = "custom-radio";
      }

      let radioHtml = `
        <input
          type="radio"
          class="${radioElClass}" 
          name=${name}
          id="${value}"
          value="${value}"
          data-title="${item.title}"
          data-topsqty="${topsQty}"
          data-sale="${sale}"
          data-value="${value}"
          data-top_1_sku="${top_1_sku}"
          data-top_1_id="${top_1_id}"
          data-top_1_grommetqty="${top_1_grommetQty}"
          data-top_1_grommetsize="${top_1_grommetSize}"
          data-top_2_sku="${top_2_sku}"
          data-top_2_id="${top_2_id}"
          data-top_2_grommetqty="${top_2_grommetQty}"
          data-top_2_grommetsize="${top_2_grommetSize}"
          data-index=${index}
          ${selectSingle}
          >
        <label 
        for="${value}" 
        data-sale="${sale}"
        class="${name}_${value} ${colorOptionClassName}">
          ${title}</label>
        `;

      radioHtml.itemdata = item;
      select.insertAdjacentHTML("beforeend", radioHtml);
    });
    select.disabled = false;
  }

  updateSizeElement(data, size_s, "size", 1);
  updateSizeElement(data, size_m, "size", 2);
  updateSizeElement(data, size_l, "size", 3);
  //updateSizeElement(data,size_pb,'size',4);

  updateRadioElement(data[0].suboptions, materialWrapper, "material");
  updateRadioElement(data[0].suboptions[0].suboptions, colorWrapper, "color");

  //Preselected options start
  sizeInputs.forEach((input) => {
    if (input.checked) {
      selectedSize.innerHTML = input.value;
    }
  });

  materials.forEach((input) => {
    if (input.checked) {
      selectedMaterial.innerHTML = input.dataset.title;
    }
  });
  colorInputs.forEach((input) => {
    if (input.checked) {
      selectedColor.innerHTML = input.value;
    }
  });
  frameColors.forEach((input) => {
    if (input.checked) {
      selectedFrame.innerHTML = input.value;
    }
  });
  //Preselected options end

  let arrMaterial = [];
  let arrcolor = [];

  document.getElementById("variant-size").addEventListener("change", (e) => {
    let optVal = e.target.value;
    let elIndex = +e.target.dataset.index;

    if (optVal) {
      selectedSize.innerHTML = optVal;
    } else {
      selectedSize.innerHTML = "";
    }

    const selected_size_s_Value = document.querySelector(
      "#s_size_top .selected-value"
    );
    const selected_size_m_Value = document.querySelector(
      "#m_size_top .selected-value"
    );
    const selected_size_l_Value = document.querySelector(
      "#l_size_top .selected-value"
    );

    if (optVal == "59x59") {
      selected_size_m_Value.textContent = "M";
      selected_size_l_Value.textContent = "L";
      selected_size_s_Value.textContent = "S";
      size_m_Select.classList.remove("active");
      size_s_Select.classList.remove("active");
      size_l_Select.classList.remove("active");
    }

    arrMaterial = data[elIndex];

    if (arrMaterial.suboptions) {
      updateRadioElement(arrMaterial.suboptions, materialWrapper, "material");
      updateRadioElement(
        arrMaterial.suboptions[0].suboptions,
        colorWrapper,
        "color"
      );
      selectedMaterial.innerHTML = "";
    }
    //deselectGrommets();
    onCheckStock();
    return arrMaterial;
  });

  document
    .getElementById("variant-material")
    .addEventListener("change", (e) => {
      let optVal = e.target.dataset.title;
      let elIndex = +e.target.dataset.index;

      if (optVal) {
        selectedMaterial.innerHTML = optVal;
      } else {
        selectedMaterial.innerHTML = "";
      }

      arrColor = arrMaterial.suboptions[elIndex];
      if (arrColor) {
        updateRadioElement(arrColor.suboptions, colorWrapper, "color");
      } else {
        colorWrapper.innerHTML = "";
      }
      selectedColor.innerHTML = "";
      onCheckStock();
      //deselectGrommets();
    });

  function onCheckStock() {
    const selColorOpt = document.getElementsByName("color");
    const topJson = document.querySelector(
      "#hidden-variant-metafields-container"
    ).innerHTML;
    const topVariants = JSON.parse(topJson);

    let firstavailible = true;
    let secondavailible = true;

    selColorOpt.forEach(function (color) {
      let id_first = color.dataset.top_1_id;
      let id_second = color.dataset.top_2_id;
      let leftTopAvailable = true;
      let rightTopAvailable = true;

      if (id_first) {
        leftTopAvailable = Array.from(topVariants).filter(
          (elem) => +elem.variant_id == +id_first
        )[0].variant_available;
      }
      if (id_second) {
        rightTopAvailable = Array.from(topVariants).filter(
          (elem) => +elem.variant_id == +id_second
        )[0].variant_available;
      }

      if (leftTopAvailable == "false" || rightTopAvailable == "false") {
        color.classList.add("soldout");
        color.disabled = true;
      } else {
        color.classList.remove("soldout");
        color.disabled = false;
      }
    });
  }
  onCheckStock();

  document.getElementById("variant-color").addEventListener("change", (e) => {
    let optVal = e.target.dataset.title;
    if (optVal) {
      selectedColor.innerHTML = optVal;
    } else {
      selectedColor.innerHTML = "";
    }
    preselectGrommets();
  });

  function preselectGrommets() {
    const leftGrommetsList = document.querySelectorAll(
      "#leftTopGrommet .grommet-item"
    );
    const rightGrommetsList = document.querySelectorAll(
      "#rightTopGrommet .grommet-item"
    );

    const leftTopGrommet = document.getElementById("leftTopGrommet");
    const rightTopGrommet = document.getElementById("rightTopGrommet");
    const leftTopGrommetBtn = document.querySelector("#leftTopGrommet button");
    const rightTopGrommetBtn = document.querySelector(
      "#rightTopGrommet button"
    );

    const leftGrommetQty = document.querySelectorAll(
      "#leftTopGrommet .grommet-item .acc-quantity"
    );
    const rightGrommetQty = document.querySelectorAll(
      "#rightTopGrommet .grommet-item .acc-quantity"
    );

    const rightGrommets = document.getElementsByName("r-grommet-product");
    const leftGrommets = document.getElementsByName("l-grommet-product");
    const leftSelectedGrommetValue = document.querySelector(
      "#leftTopGrommet .selected-value"
    );
    const rightSelectedGrommetValue = document.querySelector(
      "#rightTopGrommet .selected-value"
    );
    const colors = document.getElementsByName("color");
    const selected = Array.from(colors).filter((elem) => elem.checked)[0];

    leftGrommetSize = selected.dataset.top_1_grommetsize;
    leftGrommetCount = parseFloat(selected.dataset.top_1_grommetqty);

    if (leftGrommetCount != 0) {
      leftTopGrommetBtn.disabled = false;
      leftTopGrommet.classList.remove("hide");
      leftGrommetQty.forEach((el) => (el.innerHTML = `x ${leftGrommetCount}`));

      leftGrommetsList.forEach((elem) => {
        if (!elem.classList.contains(leftGrommetSize)) {
          elem.classList.add("hide");
        } else {
          elem.classList.remove("hide");
        }
      });

      //Preselect left top grommet
      let preselectedLeft = Array.from(leftGrommetsList).filter(
        (elem) => !elem.classList.contains("hide")
      )[0];
      let peselected_l_Input = preselectedLeft.querySelector("input");
      peselected_l_Input.checked = true;
      let preselected_l_Price = peselected_l_Input.dataset.price / 100;
      leftSelectedGrommetValue.textContent = `${preselected_l_Price} CAD x ${leftGrommetCount} ${peselected_l_Input.dataset.sku}`;
    } else {
      leftTopGrommetBtn.disabled = true;
      leftTopGrommet.classList.add("hide");
      leftGrommetQty.forEach((el) => (el.innerHTML = ""));
      leftSelectedGrommetValue.textContent = "Select Table Top";
    }

    rightGrommetSize = selected.dataset.top_2_grommetsize;
    rightGrommetCount = parseFloat(selected.dataset.top_2_grommetqty);

    if (rightGrommetCount != 0) {
      rightTopGrommetBtn.disabled = false;
      rightTopGrommet.classList.remove("hide");
      rightGrommetQty.forEach(
        (el) => (el.innerHTML = `x ${rightGrommetCount}`)
      );

      rightGrommetsList.forEach((elem) => {
        if (!elem.classList.contains(rightGrommetSize)) {
          elem.classList.add("hide");
        } else {
          elem.classList.remove("hide");
        }
      });

      //Preselect Right top grommet
      let preselectedRight = Array.from(rightGrommetsList).filter(
        (elem) => !elem.classList.contains("hide")
      )[0];
      let peselected_r_Input = preselectedRight.querySelector("input");
      peselected_r_Input.checked = true;
      let preselected_r_Price = peselected_r_Input.dataset.price / 100;
      rightSelectedGrommetValue.textContent = `${preselected_r_Price} CAD x ${rightGrommetCount} ${peselected_r_Input.dataset.sku}`;
    } else {
      rightTopGrommetBtn.disabled = true;
      rightTopGrommet.classList.add("hide");
      rightGrommetQty.forEach((el) => (el.innerHTML = ""));
      rightSelectedGrommetValue.textContent = "Select Table Top";
    }
  }

  const grommetSelectLeft = document.querySelector("#leftTopGrommet");
  const grommetSelectBtnLeft = document.querySelector(
    "#leftTopGrommet .select-button"
  );
  const leftSelectedGrommetValue = document.querySelector(
    "#leftTopGrommet .selected-value"
  );
  const leftGrommetOptionsList = document.querySelectorAll(
    "#leftTopGrommet .select-dropdown li"
  );

  grommetSelectBtnLeft.addEventListener("click", () => {
    grommetSelectLeft.classList.toggle("active");
    grommetSelectBtnLeft.setAttribute(
      "aria-expanded",
      grommetSelectBtnLeft.getAttribute("aria-expanded") === "true"
        ? "false"
        : "true"
    );
  });
  leftGrommetOptionsList.forEach(function (option) {
    function handler(e) {
      if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
        leftSelectedGrommetValue.textContent = this.children[1].textContent;
        grommetSelectLeft.classList.remove("active");
      }
      // Key Events
      if (e.key === "Enter") {
        leftSelectedGrommetValue.textContent = this.textContent;
        grommetSelectLeft.classList.remove("active");
      }
    }

    option.addEventListener("keyup", handler);
    option.addEventListener("click", handler);
  });

  const grommetSelectRight = document.querySelector("#rightTopGrommet");
  const grommetSelectBtnRight = document.querySelector(
    "#rightTopGrommet .select-button"
  );
  const rightSelectedGrommetValue = document.querySelector(
    "#rightTopGrommet .selected-value"
  );
  const rightGrommetOptionsList = document.querySelectorAll(
    "#rightTopGrommet .select-dropdown li"
  );

  grommetSelectBtnRight.addEventListener("click", () => {
    grommetSelectRight.classList.toggle("active");
    grommetSelectBtnRight.setAttribute(
      "aria-expanded",
      grommetSelectBtnRight.getAttribute("aria-expanded") === "true"
        ? "false"
        : "true"
    );
  });

  rightGrommetOptionsList.forEach(function (option) {
    function handler(e) {
      if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
        rightSelectedGrommetValue.textContent = this.children[1].textContent;
        grommetSelectRight.classList.remove("active");
      }
      // Key Events
      if (e.key === "Enter") {
        rightSelectedGrommetValue.textContent = this.textContent;
        grommetSelectRight.classList.remove("active");
      }
    }

    option.addEventListener("keyup", handler);
    option.addEventListener("click", handler);
  });

  const allRemotes = document.getElementsByName("remote-product");
  allRemotes.forEach((remote) => {
    if (remote.checked) {
      selectedRemoteValue.textContent = remote.dataset.sku;
    }
  });

  remoteSelectBtn.addEventListener("click", () => {
    remoteSelect.classList.toggle("active");
    remoteSelectBtn.setAttribute(
      "aria-expanded",
      remoteSelectBtn.getAttribute("aria-expanded") === "true"
        ? "false"
        : "true"
    );
  });
  remoteOptionsList.forEach((option) => {
    function handler(e) {
      if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
        if (this.children[0].checked) {
          selectedRemoteValue.textContent = this.children[1].textContent;
        } else {
          selectedRemoteValue.textContent = "Choose Remote";
        }

        remoteSelect.classList.remove("active");
      }
      // Key Events
      if (e.key === "Enter") {
        selectedRemoteValue.textContent = this.textContent;
        remoteSelect.classList.remove("active");
      }
    }

    option.addEventListener("keyup", handler);
    option.addEventListener("click", handler);
  });

  //Size Options
  const selected_size_s_Value = document.querySelector(
    "#s_size_top .selected-value"
  );
  const selected_size_m_Value = document.querySelector(
    "#m_size_top .selected-value"
  );
  const selected_size_l_Value = document.querySelector(
    "#l_size_top .selected-value"
  );

  size_s_SelectBtn.addEventListener("click", function (e) {
    size_s_Select.classList.toggle("active");
    size_s_SelectBtn.setAttribute(
      "aria-expanded",
      size_s_SelectBtn.getAttribute("aria-expanded") === "true"
        ? "false"
        : "true"
    );

    size_m_Select.classList.remove("active");
    size_l_Select.classList.remove("active");

    const size_s_OptionsList = document.querySelectorAll(
      "#s_size_top .select-dropdown li"
    );

    size_s_OptionsList.forEach(function (option) {
      function handler(e) {
        if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
          if (this.children[0].checked) {
            selected_size_s_Value.textContent = this.children[1].textContent;
            selected_size_m_Value.textContent = "M";
            selected_size_l_Value.textContent = "L";
          } else {
            selected_size_s_Value.textContent = "S";
          }

          size_s_Select.classList.remove("active");
        }
        // Key Events
        if (e.key === "Enter") {
          selected_size_s_Value.textContent = this.textContent;
          size_s_Select.classList.remove("active");
        }
      }

      option.addEventListener("keyup", handler);
      option.addEventListener("click", handler);
    });
  });

  size_m_SelectBtn.addEventListener("click", () => {
    size_m_Select.classList.toggle("active");
    size_m_SelectBtn.setAttribute(
      "aria-expanded",
      size_m_SelectBtn.getAttribute("aria-expanded") === "true"
        ? "false"
        : "true"
    );
    size_s_Select.classList.remove("active");
    size_l_Select.classList.remove("active");

    const size_m_OptionsList = document.querySelectorAll(
      "#m_size_top .select-dropdown li"
    );

    size_m_OptionsList.forEach((option) => {
      function handler(e) {
        if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
          if (this.children[0].checked) {
            selected_size_m_Value.textContent = this.children[1].textContent;
            selected_size_s_Value.textContent = "S";
            selected_size_l_Value.textContent = "L";
          } else {
            selected_size_m_Value.textContent = "M";
          }

          size_m_Select.classList.remove("active");
        }
        // Key Events
        if (e.key === "Enter") {
          selected_size_m_Value.textContent = this.textContent;
          size_m_Select.classList.remove("active");
        }
      }

      option.addEventListener("keyup", handler);
      option.addEventListener("click", handler);
    });
  });

  size_l_SelectBtn.addEventListener("click", () => {
    size_l_Select.classList.toggle("active");
    size_l_SelectBtn.setAttribute(
      "aria-expanded",
      size_l_SelectBtn.getAttribute("aria-expanded") === "true"
        ? "false"
        : "true"
    );
    size_s_Select.classList.remove("active");
    size_m_Select.classList.remove("active");

    const size_l_OptionsList = document.querySelectorAll(
      "#l_size_top .select-dropdown li"
    );
    size_l_OptionsList.forEach((option) => {
      function handler(e) {
        if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
          if (this.children[0].checked) {
            selected_size_l_Value.textContent = this.children[1].textContent;
            selected_size_m_Value.textContent = "M";
            selected_size_s_Value.textContent = "S";
          } else {
            selected_size_l_Value.textContent = "L";
          }

          size_l_Select.classList.remove("active");
        }
        // Key Events
        if (e.key === "Enter") {
          selected_size_l_Value.textContent = this.textContent;
          size_l_Select.classList.remove("active");
        }
      }

      option.addEventListener("keyup", handler);
      option.addEventListener("click", handler);
    });
  });
});

// ##### Corner Top Builder Code start #####

let cornerOptions = {};
let cornerFrameOptions = {};
let cornerSelectedGrommet = {};
let cornerSelectedremote = {};
let cornerProducts = [];

class CornerBuilder extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onBuilderChange);
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.cartBtn = document.querySelector("#BuilderSubmitButton");

    this.media_gallery = document.querySelector(
      ".product__media-wrapper media-gallery"
    );
    this.deskTableSlide = this.media_gallery.querySelector(
      ".desk-image-container"
    );
    this.deskTableThumbnail = this.media_gallery.querySelector(
      ".thumbnail-desk-image-container"
    );
    this.firstDefaultGalleryThumbnail =
      this.deskTableThumbnail.nextElementSibling;
    this.deskTableThumbnailButton =
      this.deskTableThumbnail.querySelector("button");
    this.firstDefaultGalleryThumbnailButton =
      this.firstDefaultGalleryThumbnail.querySelector("button");

    this.cartBtn.addEventListener("click", (e) => {
      e.preventDefault();

      const colorOptions = document.getElementsByName("color");
      const sizeOptions = document.getElementsByName("size");
      const frameOptions = document.getElementsByName("frame_color");
      const deskremotes = document.getElementsByName("remote-product");
      const leftGrommetsList = document.querySelectorAll(
        "#leftTopGrommet .grommet-input"
      );
      const rightGrommetsList = document.querySelectorAll(
        "#rightTopGrommet .grommet-input"
      );

      // Selection errors start
      function selectionCheck(inputs, errorSelector, message) {
        //let inputs = document.getElementsByName(name);
        let errorWrapper = document.querySelector(errorSelector);
        document.querySelector(".remote-errors");

        let isSelected = false;
        if (inputs.length) {
          inputs.forEach((elem) => {
            if (elem.checked) {
              isSelected = true;
            }
          });
        }
        if(errorWrapper) {
          if(isSelected ) {
            return;
          } else {
            errorWrapper.innerHTML = `<span class="builder-errors">${message}</span>`;
            setTimeout(() => errorWrapper.innerHTML = '', 2000);
          }
        }
      }


      selectionCheck(colorOptions, "#selectedColor", "Select Color");
      selectionCheck(sizeOptions, "#selectedSize", "Select Size");
      selectionCheck(frameOptions, "#selectedFrame", "Select Frame Color");

      if (cornerOptions.top_1_grommetQty != 0) {
        selectionCheck(
          leftGrommetsList,
          "#selectedGrommet_1",
          "Select Grommet"
        );
      }
      if (cornerOptions.top_2_grommetQty != 0) {
        selectionCheck(
          rightGrommetsList,
          "#selectedGrommet_2",
          "Select Grommet"
        );
      }

      selectionCheck(deskremotes, "#selectedRemote", "Select Remote");

      // Selection errors end
      if (
        cornerOptions.selectedSize &&
        cornerFrameOptions.frameId &&
        ((cornerOptions.top_1_grommetQty != 0 &&
          cornerSelectedGrommet.leftGrommetId) ||
          cornerOptions.top_1_grommetQty == 0) &&
        ((cornerOptions.top_2_grommetQty != 0 &&
          cornerSelectedGrommet.rightGrommetId) ||
          cornerOptions.top_2_grommetQty == 0) &&
        cornerSelectedremote.remoteId
      ) {
        this.cartBtn.setAttribute("aria-disabled", true);
        this.cartBtn.classList.add("loading");
        const btn_overlay = this.cartBtn.querySelector(
          ".loading-overlay__spinner"
        );

        if (btn_overlay) {
          btn_overlay.classList.remove("hidden");
        }

        const request = JSON.parse(JSON.stringify(cornerProducts));

        request.map(el => {
          if (el.properties._desk_id) {
            el.properties._desk_id = el.properties._desk_id+Date.now().toString(36);
          }
          return el 
        })


        const cartData = request.map((r) => ({
          id: r.id,
          quantity: r.quantity,
          properties: r.properties,
        }));


        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        const formData = {};

        formData.items = cartData;
        if (this.cart) {
          formData.sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.cartBtn.setAttribute("aria-disabled", true);
              this.cartBtn.querySelector("span").classList.add("hidden");
              this.error = true;
              if (btn_overlay) {
                btn_overlay.classList.add("hidden");
              }
              this.handleErrorMessage(response.description);

              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            

            const builder_upsell_product_modalEl = document.querySelector(
              "submit-upsell-modal"
            );
            if (builder_upsell_product_modalEl) {
              builder_upsell_product_modalEl.openFormModal();
            }

            const upsell__modal = this.closest(".upsell__modal");
            if (upsell__modal) {
              upsell__modal.classList.remove("is-open");
            }

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.cartBtn.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.cartBtn.removeAttribute("aria-disabled");

            if (btn_overlay) {
              btn_overlay.classList.add("hidden");
            }
          });
      }
    });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  onBuilderChange() {
    this.selectTableTop();
    this.onFrameChange();
    this.onGrommetChange();
    this.onRemoteChange();
    this.onPriceUpdate();
    if (cornerOptions.topQuantity && cornerFrameOptions.frameId) {
      this.deskRender();
    } else {
      this.deskHide();
    }
    this.onBundleCreate();
  }

  //Methods
  selectTableTop() {
    cornerOptions = {};
    let selectedMaterial = null,
      selectedColor = null,
      selectedSize = null,
      topQuantity = null,
      top_1_sku = null,
      top_1_id = null,
      top_1_grommetQty = null,
      top_1_grommetSize = null,
      top_1_price = null,
      top_2_sku = null,
      top_2_id = null,
      top_2_grommetQty = null,
      top_2_grommetSize = null,
      top_2_price = null,
      topLeftAvailible = true,
      topRightAvailible = true,
      top_totlal_price = null;

    const materialOptions = document.getElementsByName("material");
    const colorOptions = document.getElementsByName("color");
    const sizeOptions = document.getElementsByName("size");
    const leftTopGrommet = document.getElementById("leftTopGrommet");
    const rightTopGrommet = document.getElementById("rightTopGrommet");
    const leftTopGrommetBtn = document.querySelector("#leftTopGrommet button");
    const rightTopGrommetBtn = document.querySelector(
      "#rightTopGrommet button"
    );
    const allGrommets = document.getElementsByName("grommet-product");
    const leftSelectedGrommetValue = document.querySelector(
      "#leftTopGrommet .selected-value"
    );
    const rightSelectedGrommetValue = document.querySelector(
      "#rightTopGrommet .selected-value"
    );
    const leftGrommetsList = document.querySelectorAll(
      "#leftTopGrommet .grommet-item"
    );
    const rightGrommetsList = document.querySelectorAll(
      "#rightTopGrommet .grommet-item"
    );
    const leftGrommetQty = document.querySelectorAll(
      "#leftTopGrommet .grommet-item .acc-quantity"
    );
    const rightGrommetQty = document.querySelectorAll(
      "#rightTopGrommet .grommet-item .acc-quantity"
    );

    // check selected size
    sizeOptions.forEach((size) => {
      if (size.checked) {
        selectedSize = size.value;
      }
    });
    // check selected material
    materialOptions.forEach((material) => {
      if (material.checked) {
        selectedMaterial = material.value;
      }
    });
    // check selected color
    colorOptions.forEach((color) => {
      if (color.checked) {
        selectedColor = color.value;
        topQuantity = parseFloat(color.dataset.topsqty);
        top_1_sku = color.dataset.top_1_sku;
        top_1_id = parseFloat(color.dataset.top_1_id);
        top_1_grommetQty = parseFloat(color.dataset.top_1_grommetqty);
        top_1_grommetSize = color.dataset.top_1_grommetsize;
        top_2_sku = color.dataset.top_2_sku;
        top_2_id = parseFloat(color.dataset.top_2_id);
        top_2_grommetQty = parseFloat(color.dataset.top_2_grommetqty);
        top_2_grommetSize = color.dataset.top_2_grommetsize;
      }
    });
    if (selectedColor) {
      const topJson = document.querySelector(
        "#hidden-variant-metafields-container"
      ).innerHTML;
      const topVariants = JSON.parse(topJson);

      topVariants.forEach(function (el) {
        if (top_1_id == +el.variant_id) {
          top_1_price = Math.round(el.variant_price);
          topLeftAvailible = el.variant_available;
        }
        if (top_2_id == +el.variant_id) {
          top_2_price = Math.round(el.variant_price);
          topRightAvailible = el.variant_available;
        }
      });

      if (top_1_price && top_2_price) {
        top_totlal_price = +top_1_price + top_2_price;
      }

      cornerOptions = {
        selectedMaterial,
        selectedColor,
        selectedSize,
        topQuantity,
        top_1_sku,
        top_1_id,
        top_1_grommetQty,
        top_1_grommetSize,
        top_1_price,
        top_2_sku,
        top_2_id,
        top_2_grommetQty,
        top_2_grommetSize,
        top_2_price,
      };
    } else {
      cornerOptions = {};
      //uncheck selected grommets
      allGrommets.forEach((elem) => {
        if (elem.checked) {
          elem.checked = false;
        }
      });
      leftTopGrommet.classList.remove("active");
      rightTopGrommet.classList.remove("active");
      leftSelectedGrommetValue.textContent = "Choose Tabletop Grommet(s)";
      rightSelectedGrommetValue.textContent = "Choose Tabletop Grommet(s)";
      leftTopGrommetBtn.setAttribute("disabled", "");
      rightTopGrommetBtn.setAttribute("disabled", "");
      leftTopGrommet.classList.remove("hide");
      rightTopGrommet.classList.remove("hide");
      rightGrommetQty.forEach((el) => (el.innerHTML = ""));
      leftGrommetQty.forEach((el) => (el.innerHTML = ""));
    }
  }

  onFrameChange() {
    cornerFrameOptions = {};
    const selFrameOpt = document.getElementsByName("frame_color");
    const selectedFrameSpan = document.querySelector("#selectedFrame");
    let frameId = null,
      framePrice = null,
      frameSku = null,
      frameValue = "";

    selFrameOpt.forEach((el) => {
      if (el.checked) {
        frameId = parseFloat(el.id);
        framePrice = Math.round(el.dataset.price);
        frameSku = el.dataset.variantsku;
        frameValue = el.value;
      }
    });
    if (frameId && framePrice) {
      cornerFrameOptions = {
        frameId,
        framePrice,
        frameSku,
      };
      selectedFrameSpan.innerHTML = frameValue;
    } else {
      cornerFrameOptions = {};
      selectedFrameSpan.innerHTML = "";
    }
    return cornerFrameOptions;
  }
  onGrommetChange() {
    cornerSelectedGrommet = {};
    let leftGrommetId = null,
      leftGrommetSku = null,
      leftGrommetPrice = null,
      rightGrommetId = null,
      rightGrommetSku = null,
      rightGrommetPrice = null;
    const leftGrommetsList = document.querySelectorAll(
      "#leftTopGrommet .grommet-input"
    );
    const rightGrommetsList = document.querySelectorAll(
      "#rightTopGrommet .grommet-input"
    );

    leftGrommetsList.forEach(function (elem) {
      if (elem.checked) {
        leftGrommetId = parseFloat(elem.value);
        leftGrommetSku = elem.dataset.sku;
        leftGrommetPrice = Math.round(elem.dataset.price);
      }
    });
    rightGrommetsList.forEach(function (elem) {
      if (elem.checked) {
        rightGrommetId = parseFloat(elem.value);
        rightGrommetSku = elem.dataset.sku;
        rightGrommetPrice = Math.round(elem.dataset.price);
      }
    });
    cornerSelectedGrommet = {
      leftGrommetId,
      leftGrommetSku,
      leftGrommetPrice,
      rightGrommetId,
      rightGrommetSku,
      rightGrommetPrice,
    };
    return cornerSelectedGrommet;
  }
  onRemoteChange() {
    cornerSelectedremote = {};
    const cornerremotes = document.getElementsByName("remote-product");
    cornerremotes.forEach(function (elem) {
      if (elem.checked) {
        cornerSelectedremote = {
          remoteId: +elem.id,
          remoteSku: elem.dataset.sku,
        };
      }
    });
    return cornerSelectedremote;
  }
  onPriceUpdate() {
    const priceWrapper = document.querySelector(".builder-price");
    const priceFrom = document.querySelector(".starting_txt");
    const quanity_input = document.querySelector(".builder-desk-qty");
    const btnPriceEl = document.querySelector('.product-form__cart-submit-price');
    
    let qtyValue = Number(quanity_input.value);
    let topsPrice = null,
      framePrice = null,
      grommetsPrice = null,
      priceArr = [],
      deskTotalSum = null;

    const stickyVariantPriceEl = document.querySelector('.sticky-variant-price');

    let starting = Number(priceWrapper.dataset.starting);
    topsPrice = cornerOptions.top_1_price + cornerOptions.top_2_price;
    framePrice = cornerFrameOptions.framePrice;
    grommetsPrice =
      +cornerSelectedGrommet.leftGrommetPrice * cornerOptions.top_1_grommetQty +
      +cornerSelectedGrommet.rightGrommetPrice * cornerOptions.top_2_grommetQty;

    if (!isNaN(topsPrice)) {
      priceArr.push(topsPrice);
    }
    if (!isNaN(framePrice)) {
      priceArr.push(framePrice);
    }
    if (!isNaN(grommetsPrice)) {
      priceArr.push(grommetsPrice);
    }
    if (priceArr.length) {
      deskTotalSum = priceArr.reduce(function (sum, elem) {
        return sum + elem;
      }, 0);
    }
    if (deskTotalSum >= starting) {
      // window.KOSMApp.updatePurchaseAmount(deskTotalSum);

      // document
      //   .getElementsByTagName("klarna-placement")[0]
      //   .setAttribute("data-purchase-amount", deskTotalSum);
      // window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      // window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });

      priceWrapper.innerHTML = formatMoney((deskTotalSum * qtyValue), window.moneyFormat);

      if(stickyVariantPriceEl) {
        stickyVariantPriceEl.innerHTML = formatMoney((deskTotalSum * qtyValue), window.moneyFormat);
      }
      
      priceFrom.classList.add("hide");

    if(btnPriceEl) {
        btnPriceEl.innerHTML = formatMoney((deskTotalSum * qtyValue), window.moneyFormat);
        btnPriceEl.classList.remove('hide');
      }
      
    }

    // Volume Discounts
    const discountWrapper = document.querySelector(".buyMorePriceTable");
    let bulkValue = "";
    const bulkInputs = document.getElementsByName("bulk-order-input");
    const discountValues = document.querySelectorAll(".qtyRowVal");

    if (discountWrapper) {
      bulkInputs.forEach((elem) => {
        if (elem.checked) {
          bulkValue = elem.value;
        }
      });
      if (bulkValue == "multiple") {
        discountWrapper.classList.add("active");
      } else {
        discountWrapper.classList.remove("active");
      }

      if (qtyValue > 1 && !discountWrapper.classList.contains("active")) {
        discountWrapper.classList.add("active");
        bulkInputs.forEach((elem) => {
          if (elem.value == "single") {
            elem.checked = false;
          }
          if (elem.value == "multiple") {
            elem.checked = true;
          }
        });
      }

      discountValues.forEach((cell) => {
        cell.classList.remove("hightlighted");
        if (qtyValue >= cell.dataset.min && qtyValue < cell.dataset.max) {
          cell.classList.add("hightlighted");
        }
      });
    }
  }
  deskRender() {
    let deskColor = "",
      renderColor = "",
      frameSku = "",
      renderGrommetSku = "",
      fileName = "";
    let leftGrommetsCount = 0;
    let rightGrommetsCount = 0;
    let fullSize = "",
      renderSize = "";

    // const medisdeskWrapper = document.querySelector('.desk-image-container');
    const medisdeskWrapperItems = document.querySelectorAll(
      ".builder-media-wrapper"
    );

    leftGrommetsCount = cornerOptions.top_1_grommetQty;
    rightGrommetsCount = cornerOptions.top_2_grommetQty;
    fullSize = cornerOptions.selectedSize.replace("x", "");
    //fullSize = cornerOptions.selectedSize;

    switch (fullSize) {
      case "7555":
        renderSize = "7555";
        break;
      case "8355":
        renderSize = "8355";
        break;
      case "8855":
        renderSize = "9072";
        break;
      case "8560":
        renderSize = "9072";
        break;
      case "8572":
        renderSize = "8355";
        break;
      case "8850":
        renderSize = "9072";
        break;
      case "5959":
        renderSize = "90";
        break;
      default:
        renderSize = fullSize;
    }

    let topSfx = "";
    if (fullSize == "7248" || fullSize == "7260") {
      topSfx = "-N";
    }

    deskColor = cornerOptions.selectedColor;
    switch (deskColor) {
      case "WarmWhite":
        renderColor = "WW";
        break;
      case "BrightBeech":
        renderColor = "BB";
        break;
      case "GrayOak":
        renderColor = "GO";
        break;
      case "RusticHickory":
        renderColor = "RH";
        break;
      case "LightWalnut":
        renderColor = "LW";
        break;
      case "DarkCherry":
        renderColor = "DC";
        break;
      case "RoastedWalnut":
        renderColor = "RW";
        break;
      case "EbonyOak":
        renderColor = "EO";
        break;
      case "PureBlack":
        renderColor = "PB";
        break;
      case "PureBlack":
        renderColor = "PB";
        break;
      case "CoolWhite":
        renderColor = "CW";
        break;
      case "WhiteBirch":
        renderColor = "WB";
        break;
      case "SunsetTeak":
        renderColor = "ST";
        break;
      case "DarkOak":
        renderColor = "DO";
        break;
      case "MidnightMaple":
        renderColor = "MM";
        break;
      default:
        renderColor = "";
    }

    let renderFrame = "";
    frameSku = cornerFrameOptions.frameSku;
    if (frameSku == "FLT-05-Black" || frameSku == "FLT-05-White") {
      renderFrame = frameSku;
    } else {
      renderFrame = `${frameSku}-Gray`;
    }

    let doublrGrommet = "";

    // if(leftGrommetsCount == 2 || rightGrommetsCount == 2) {
    if (
      leftGrommetsCount == 2 ||
      (leftGrommetsCount == 0 && rightGrommetsCount == 2)
    ) {
      if (fullSize != "7055" && fullSize != "8355" && fullSize != "8572") {
        doublrGrommet = "D80-";
      }
    }
    if (fullSize == "7872") {
      doublrGrommet = "D80-";
    }
    if (fullSize == "8560" || fullSize == "8855") {
      doublrGrommet = "";
    }

    if (fullSize == "7260" && renderColor == "WW") {
      doublrGrommet = "";
      topSfx = "";
    }

    let grommetRender = "";

    if (
      cornerOptions.top_1_grommetQty != 0 ||
      cornerOptions.top_1_grommetQty != "0"
    ) {
      if (cornerOptions.top_1_grommetSize == "round" || fullSize == "8855") {
        grommetRender = "DA-10-B";
      } else {
        grommetRender = "DA-01-B";
      }
    }

    if (
      cornerOptions.top_1_grommetQty == 0 ||
      cornerOptions.top_1_grommetQty == "0"
    ) {
      if (cornerOptions.top_2_grommetSize == "round") {
        grommetRender = "DA-10-B";
      } else {
        grommetRender = "DA-01-B";
      }
    }
    if (fullSize == "9048" || fullSize == "9072") {
      grommetRender = "DA-10-B";
    }

    if ((fullSize == "8560" || fullSize == "8855") && (renderColor == "GO" || renderColor == "BB")) {
      doublrGrommet = "D80-";
    }

    if (fullSize == "7860" && renderColor == "DC") {doublrGrommet = "D80-";};
    if (fullSize == "7260" && renderColor == "RW") {topSfx=""};
    if (fullSize == "7260" && renderColor == "EO") {topSfx=""};
    if (fullSize == "9048" && renderColor == "RW") {renderSize="8548"};
    if (fullSize == "9048" && renderColor == "EO") {renderSize="8548"};
    if (fullSize == "8855" && renderColor == "RW") {renderSize="9072";doublrGrommet = "D80-";};
    if (fullSize == "8855" && renderColor == "DC") {renderSize="9072";doublrGrommet = "D80-";};
    if (fullSize == "8855" && renderColor == "EO") {renderSize="9072";doublrGrommet = "D80-";};
    if (fullSize == "7860" && renderColor == "RW") {renderSize="7555"};
    if (fullSize == "7860" && renderColor == "EO") {renderSize="7555"};
    if (fullSize == "7860" && renderColor == "DC") {renderSize="7555";doublrGrommet = "";};
    if (fullSize == "9060" && renderColor == "RW") {renderSize="9072";doublrGrommet='D80-';};
    if (fullSize == "9060" && renderColor == "GO") {renderSize="9072";doublrGrommet='D80-';};
    if (fullSize == "9060" && renderColor == "EO") {renderSize="9072";doublrGrommet='D80-';};
    if (fullSize == "9060" && renderColor == "DC") {renderSize="9072";doublrGrommet='D80-';};
    if (fullSize == "9048" && renderColor == "DC") {renderSize="8548";};


    if (fullSize == "9060" && renderColor == "WW" ) {
      renderSize = "8355";
      doublrGrommet = "";
      topSfx = "";
    }
    if (fullSize == "8855" && renderColor == "WW") {
      renderSize = "8355";
      doublrGrommet = "";
      topSfx = "";
    }

console.log('renderColor ',renderColor)
console.log('doublrGrommet ',doublrGrommet)

    if (renderFrame != "" && renderSize != "" && renderColor != "") {
      fileName = `SD-${renderFrame}-DT-${renderSize}-${renderColor}${topSfx}-${doublrGrommet}${grommetRender}`;
    }

    this.deskTableThumbnailImages = this.deskTableThumbnail.querySelectorAll(
      ".builder-thumb-desk-image"
    );
    console.log('desk render ',fileName)
    if (fileName != "") {
      // medisdeskWrapper.style.display = 'block';

      medisdeskWrapperItems.forEach(function (el) {
        el.style.display = "none";
        if (el.dataset.desksku.includes(fileName)) {
          el.style.display = "block";
        }
      });

      this.deskTableThumbnailImages.forEach(function (el) {
        el.style.display = "none";
        if (el.dataset.desksku.includes(fileName)) {
          el.style.display = "block";

        
          
            const sticky_variant_mediaEl = document.querySelector('sticky-variant-media');
            if(sticky_variant_mediaEl) {
              const cloneImg = el.cloneNode(true);
              cloneImg.classList.remove('builder-thumb-desk-image');
              cloneImg.classList.add('selected_media');

              const oldStickyImg = sticky_variant_mediaEl.querySelector('img');
              sticky_variant_mediaEl.replaceChild(cloneImg,oldStickyImg);
              // cloneImg.remove();
            }
        }
      });
      this.deskTableThumbnail.classList.remove("hide");
      this.deskTableSlide.classList.remove("hide");
      this.media_gallery.setActiveThumbnail(this.deskTableThumbnail);
      this.deskTableThumbnailButton.dispatchEvent(
        new Event("click", { bubbles: true })
      );
    } else {
      // medisdeskWrapper.style.display = 'none';
      medisdeskWrapperItems.forEach(function (el) {
        el.style.display = "none";
      });

      this.deskTableThumbnail.classList.add("hide");
      this.deskTableSlide.classList.add("hide");
      this.media_gallery.setActiveThumbnail(this.firstDefaultGalleryThumbnail);
      this.firstDefaultGalleryThumbnailButton.dispatchEvent(
        new Event("click", { bubbles: true })
      );
    }
  }
  deskHide() {
    const medisdeskWrapperItems = document.querySelectorAll(
      ".builder-media-wrapper"
    );
    medisdeskWrapperItems.forEach(function (el) {
      el.style.display = "none";
    });
  }

  onBundleCreate() {
    let cornerReady = false;
    cornerProducts = [];
    let quantity = 1;
    let remote_sku = null;

    const quanity_input = document.querySelector(".builder-desk-qty");
    const cartBtn = document.querySelector("#BuilderSubmitButton");
    const cartBtnTextEl = cartBtn.querySelector(
      ".product-form__cart-submit-text"
    );
    const deskType = document.querySelector("corner-builder").dataset.type;
    const  deskId = Date.now().toString(36);
    quantity = Number(quanity_input.value);
    remote_sku = cornerSelectedremote.remoteSku;


    let components = null;
    if (cornerOptions.topQuantity == 1 || cornerOptions.topQuantity == "1") {
      if (cornerSelectedremote.remoteId && remote_sku != "RT-11") {
        components = 4
      } else {
        components = 3
      }
    } else {

      if (cornerSelectedremote.remoteId && remote_sku != "RT-11") {
        components = +cornerOptions.top_1_grommetQty + cornerOptions.top_2_grommetQty + 4;
      } else {
        components = +cornerOptions.top_1_grommetQty + cornerOptions.top_2_grommetQty + 3;
      }
    }
    

    if (
      cornerOptions.topQuantity &&
      cornerFrameOptions.frameId &&
      (cornerSelectedGrommet.leftGrommetId ||
        cornerSelectedGrommet.rightGrommetId) &&
      cornerSelectedremote.remoteId
    ) {
      cornerReady = true;
    }

    if (cornerReady) {
      if (cornerOptions.topQuantity == 1 || cornerOptions.topQuantity == "1") {
        cornerProducts.push({
          id: cornerOptions.top_1_id,
          quantity: quantity,
          properties: {
            _volume_disc: "",
            _builder: "desk_builder",
            _desk_id: deskId,
            _componets: components * quantity,
            _desk_type: deskType,
            _type: "Left Tabletop",
          },
        });
      } else if (
        cornerOptions.topQuantity == 2 ||
        cornerOptions.topQuantity == "2"
      ) {
        cornerProducts.push({
          id: cornerOptions.top_1_id,
          quantity: quantity,
          properties: {
            _volume_disc: "",
            _builder: "desk_builder",
            _desk_type: deskType,
            _desk_id: deskId,
            _componets: components * quantity,
            _type: "Left Tabletop",
          },
        });
        cornerProducts.push({
          id: cornerOptions.top_2_id,
          quantity: quantity,
          properties: {
            _volume_disc: "",
            _builder: "desk_builder",
            _desk_type: deskType,
            _desk_id: deskId,
            _componets: components * quantity,
            _type: "Right Tabletop",
          },
        });
      }
      if (cornerFrameOptions.frameId) {
        cornerProducts.push({
          id: cornerFrameOptions.frameId,
          quantity: quantity,
          properties: {
            _volume_disc: "",
            _builder: "desk_builder",
            _desk_type: deskType,
            _desk_id: deskId,
            _componets: components * quantity,
            _type: "Frame",
            _remote: remote_sku,
          },
        });
      }
      if (
        cornerOptions.top_1_grommetQty != 0 ||
        cornerOptions.top_1_grommetQty != "0"
      ) {
        let leftGrommets = +cornerOptions.top_1_grommetQty * quantity;
        cornerProducts.push({
          id: cornerSelectedGrommet.leftGrommetId,
          quantity: leftGrommets,
          properties: {
            _volume_disc: "",
            _builder: "desk_builder",
            _desk_type: deskType,
            _desk_id: deskId,
            _componets: components * quantity,
            _type: "Grommet",
          },
        });
      }
      if (
        cornerOptions.top_2_grommetQty != 0 ||
        cornerOptions.top_2_grommetQty != "0"
      ) {
        let rightGrommets = +cornerOptions.top_2_grommetQty * quantity;
        cornerProducts.push({
          id: cornerSelectedGrommet.rightGrommetId,
          quantity: rightGrommets,
          properties: {
            _volume_disc: "",
            _builder: "desk_builder",
            _desk_type: deskType,
            _desk_id: deskId,
            _componets: components * quantity,
            _type: "Grommet",
          },
        });
      }

      if (cornerSelectedremote.remoteId && remote_sku != "RT-11") {
        cornerProducts.push({
          id: cornerSelectedremote.remoteId,
          quantity: quantity,
          properties: {
            _volume_disc: "",
            _builder: "desk_builder",
            _desk_type: deskType,
            _desk_id: deskId,
            _componets: components * quantity,
            _type: "Remote",
            _discount_remote: 100,
          },
        });
      }

          //Promo Gift 
          // if (promoGift) {
          //   cornerProducts.push({
          //     id: promoGift,
          //     quantity: quantity,
          //     properties: {
          //       _discounted_gift: ""
          //     },
          //   });
          // }

    } else {
      cornerProducts = [];

      this.deskTableThumbnail.classList.add("hide");
      this.deskTableSlide.classList.add("hide");
      this.media_gallery.setActiveThumbnail(this.firstDefaultGalleryThumbnail);
      this.firstDefaultGalleryThumbnailButton.dispatchEvent(
        new Event("click", { bubbles: true })
      );

      
      const sticky_variant_mediaEl = document.querySelector('sticky-variant-media');
      if(sticky_variant_mediaEl) {
        const firstImageEl = this.firstDefaultGalleryThumbnailButton.querySelector('img');
        const cloneImg = firstImageEl.cloneNode(true);
        cloneImg.classList.remove('builder-thumb-desk-image');
        cloneImg.removeAttribute('id');
        cloneImg.classList.add('selected_media');

        
        const oldStickyImg = sticky_variant_mediaEl.querySelector('img');
        sticky_variant_mediaEl.replaceChild(cloneImg,oldStickyImg);
      }
    }
    return cornerProducts;
  }
}

customElements.define('corner-builder', CornerBuilder);